import { useEffect, useState } from "react";
import { ButtonCustom } from "../../../../components/custom/button-custom";
import { ModalCustom } from "../../../../components/custom/modal-custom";
import { EmployeeResponse } from "../../../../models/response/employee";

interface AdminInfoProps {
  dataObject: EmployeeResponse;
  isOpenDetail: boolean;
  setIsOpenDetail: (value: boolean) => void;
}

export const AdminInfo = ({ dataObject, isOpenDetail, setIsOpenDetail }: AdminInfoProps) => {
  const [dataAdmin, setDataAdmin] = useState<EmployeeResponse>(new EmployeeResponse());

  useEffect(() => {
    setDataAdmin(dataObject);
  }, [dataObject]);

  const bodyModal = () => {
    return (
      <div className="flex flex-col  gap-3">
        <div className="grid grid-cols-1  gap-3">
          <div className="flex">
            <label htmlFor="employeeName" className="w-1/3 font-bold text-sm text-gray-600">
              Tên đăng nhập:
            </label>
            <span className="w-2/3 text-gray-600 font-medium text-sm">{dataAdmin.username}</span>
          </div>
          <div className="flex">
            <label htmlFor="birthday" className="w-1/3 font-bold text-sm text-gray-600">
              Mật khẩu:
            </label>
            <span className="w-2/3 text-gray-600 font-medium text-sm">{dataAdmin.password}</span>
          </div>
          <div className="flex justify-center">
            <img src={dataAdmin.totp_qr_code} alt="" />
          </div>
        </div>
      </div>
    );
  };
  const footerModal = () => {
    return (
      <ButtonCustom
        type="button"
        text="Đóng"
        onClick={() => {
          setIsOpenDetail(false);
        }}
        className="bg-gray-100 text-gray-500 hover:bg-gray-400 hover:text-white"
      />
    );
  };

  return (
    <ModalCustom
      isOpen={isOpenDetail}
      setIsOpen={setIsOpenDetail}
      titleModal="Thông tin đăng nhập"
      bodyModal={bodyModal()}
      footerModal={footerModal()}
      modalSize={"40%"}
    />
  );
};
